import { memo, useCallback } from "react";
import { SimpleSelect, SimpleSelectProps } from "../../selects";
import { UNITS } from "../constants";
import { formatValue } from "../converter";
import { ClockFormat, LeadingZero, Locale, PeriodType } from "../types";
import { useCronFieldProps } from "./utils";

export type MinutesProps = Omit<SimpleSelectProps<number>, "onChange" | "options"> & {
  locale: Locale
  onChange?: ((newValue: number[]) => void) | undefined
  leadingZero: LeadingZero
  clockFormat?: ClockFormat
  period: PeriodType
};

export const Minutes = memo((
  {
    locale,
    leadingZero,
    clockFormat,
    period,
    ...props
  }: MinutesProps) => {
  const unit = UNITS.find(x => x.type === "minutes")!;
  const { options, onChange, isMulti } = useCronFieldProps(
    props.value,
    props.onChange,
    props.isMulti ?? false,
    unit,
  );

  const setOptionLabel = useCallback((v: number) => formatValue(v, unit, undefined, leadingZero, clockFormat),
    [ leadingZero, clockFormat, unit ]);

  return (
    <div>
      {(period === "hour" && locale.prefixMinutesForHourPeriod !== "") && (
        <span>
          {locale.prefixMinutesForHourPeriod}
        </span>
      )}
      {(period !== "hour" && locale.prefixMinutes !== "") && (
        <span>
          {locale.prefixMinutes}
        </span>
      )}

      <SimpleSelect
        placeholder={period === "hour" ? locale.emptyMinutesForHourPeriod : locale.emptyMinutes}
        isClearable
        isSearchable
        {...props}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        getOptionLabel={setOptionLabel}
      />

      {period === "hour" && locale.suffixMinutesForHourPeriod !== "" && (
        <span>
          {locale.suffixMinutesForHourPeriod}
        </span>
      )}
    </div>
  );
});